import { Stack } from '@mantine/core';
import type { EmbeddedPromptOut } from '@repo/api-codegen';
import { memo } from 'react';
import { AgentMessage } from './AgentMessage';
import { UserMessage } from './UserMessage';

export const MessageGroup = memo(
	({ prompt }: { prompt: EmbeddedPromptOut }) => (
		<Stack spacing="5xl">
			<UserMessage prompt={prompt} />
			<AgentMessage prompt={prompt} />
		</Stack>
	)
);
